import * as React from 'react';
import { connect } from 'react-redux';

import { navigate } from '~/router';
import { getLocationById, getOrgLocations, updateLocation } from '../../actions/locations';

import LocationFormOverlay from '../../components/locations/LocationFormOverlay';

import Loader from '~/common/components/Loader';


class LocationEditPopup extends React.Component<any, any> {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getLocationById(this.props.locationId));
  }

  onSubmit = (data) => {
    const { dispatch, orgId, locationId } = this.props;

    return dispatch(updateLocation(locationId, data))
      .then(() => {
        // TODO: Use refresh
        dispatch(getOrgLocations(orgId));
        this.props.onReturn();
      });
  }

  onClose = () => {
    this.props.onReturn();
  }

  render() {
    const { locations, locationId } = this.props;
    const location = locations.entities[locationId];

    if (locations.ui.loading) {
      return (
        <Loader className="load--ol" />
      );
    }

    return (
      <LocationFormOverlay
        headTitle="Edit Location"
        onSubmit={this.onSubmit}
        onClose={this.onClose}
        location={location}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locations: state.shared.locations,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationEditPopup) as any;
